// Gatsby supports TypeScript natively!
import React from "react"
import { PageProps, Link } from "gatsby"

import Layout from "../components/layout"
import SEO from "../components/seo"

const Page6 = (props: PageProps) => (
  
  <Layout backgroundColor="rgb(40,40,40)">
    <SEO title="Sketch #10" />
    {/* <Link to="/">Back</Link>   */}


    <div className="flex justify-center">
      <div className="w-full md:w-2/3">
        <iframe src="https://yanngraf.github.io/codesbars/011_codebars-paper-cache2-embed/" width="100%" height="800"></iframe>
      </div>
    </div>

    
  </Layout>
)

export default Page6